// extracted by mini-css-extract-plugin
export var chevronIcon = "_b7-2";
export var teamName = "_b7-1";
export var teamSwitcherButton = "_b7-0";